import _styled from "styled-components";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { useMemo } from 'react';
import Cookies from 'js-cookie';
import Paragraph from '../paragraph';
import { MenuSelector } from '../menu-selector';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var LocaleSelector = function LocaleSelector(_ref) {
  var onChange = _ref.onChange,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 'it' : _ref$value,
      _ref$background = _ref.background,
      background = _ref$background === void 0 ? 'white' : _ref$background;
  var localeList = useMemo(function () {
    return [{
      countryCode: 'IT',
      displayCode: 'IT',
      language: 'Italiano',
      value: 'it'
    }, {
      countryCode: 'GB',
      displayCode: 'EN',
      language: 'English',
      value: 'en'
    }];
  }, []);

  var getFlag = function getFlag(countryCode) {
    return "https://purecatamphetamine.github.io/country-flag-icons/3x2/".concat(countryCode, ".svg");
  };

  var localeOptions = useMemo(function () {
    return localeList.map(function (locale) {
      return {
        label: /*#__PURE__*/_jsxs(_StyledDiv, {
          children: [/*#__PURE__*/_jsx("img", {
            src: getFlag(locale.countryCode),
            width: 20,
            height: 14,
            alt: locale.countryCode
          }), /*#__PURE__*/_jsx("span", {
            children: locale.language
          })]
        }),
        value: locale.value
      };
    });
  }, [localeList]);
  var defaultLocaleLabel = useMemo(function () {
    var selectedLocale = localeList.find(function (locale) {
      return locale.value === value;
    });
    if (!selectedLocale) return null;
    return /*#__PURE__*/_jsxs(_StyledDiv2, {
      children: [/*#__PURE__*/_jsx("img", {
        src: getFlag(selectedLocale.countryCode),
        width: 20,
        height: 14,
        alt: selectedLocale.countryCode
      }), /*#__PURE__*/_jsx(Paragraph, {
        standardVariant: "label-m",
        font: "normal",
        color: "black",
        children: "".concat(selectedLocale.language, " (").concat(selectedLocale.displayCode, ")")
      })]
    });
  }, [localeList, value]);
  return /*#__PURE__*/_jsx(MenuSelector, {
    options: localeOptions,
    onSelect: function onSelect(value) {
      Cookies.set('NEXT_LOCALE', value, {
        expires: 365 * 24 * 60 * 60
      });
      onChange(value);
    },
    selectedLabel: defaultLocaleLabel,
    menuDialogStyles: [{
      "width": "174px",
      "paddingLeft": "0.25rem",
      "paddingRight": "0.25rem"
    }],
    menuButtonStyles: [{
      "gap": "0.25rem",
      "borderRadius": "0.5rem",
      "borderWidth": "1px",
      "--tw-border-opacity": "1",
      "borderColor": "rgb(229 231 235 / var(--tw-border-opacity))",
      "paddingLeft": "1rem",
      "paddingRight": "1rem",
      "paddingTop": "0.75rem",
      "paddingBottom": "0.75rem",
      "fontSize": "1rem",
      "lineHeight": "1.5rem"
    }],
    menuItemStyles: [{
      "paddingLeft": "0.25rem",
      "paddingRight": "0.25rem",
      "fontSize": "1rem",
      "lineHeight": "1.5rem",
      "fontWeight": "400",
      "@media (min-width: 1024px)": {
        "fontSize": "1rem",
        "lineHeight": "1.5rem"
      }
    }],
    background: background
  });
};
export default LocaleSelector;

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "locale-selector___StyledDiv",
  componentId: "sc-12j0byk-0"
})({
  "display": "flex",
  "flexDirection": "row",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "gap": "0.5rem"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "locale-selector___StyledDiv2",
  componentId: "sc-12j0byk-1"
})({
  "display": "flex",
  "alignItems": "center",
  "gap": "0.5rem"
});